import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const APP_COUNTRY_BLOCKER: InjectionToken<string[]> = new InjectionToken<string[]>('appCountryBlocker');
